import { getRedirect } from "app/redirects";
import { redirect } from "react-router";

export function loader({ request }: { request: Request }) {
	const newUrl = getRedirect(request);
	if (newUrl) {
		return redirect(newUrl, 301);
	}

	return;
}

export default function RedirectPage() {
	return null;
}
